import React from 'react'

const AttentionOutline = (props) => (
  <svg width={props.width ? props.width : 64}
       height={props.height ? props.height : 64}
       fill={props.color ? props.color : '#1D79FB'}
       viewBox="0 0 64 64"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd"
          d="M31.972 5.3335C17.252 5.3335 5.33203 17.2802 5.33203 32.0002C5.33203 46.7202 17.252 58.6668 31.972 58.6668C46.7187 58.6668 58.6654 46.7202 58.6654 32.0002C58.6654 17.2802 46.7187 5.3335 31.972 5.3335ZM34.6654 34.6668V18.6668H29.332V34.6668H34.6654ZM34.6654 45.3335V40.0002H29.332V45.3335H34.6654ZM10.6654 32.0002C10.6654 43.7868 20.212 53.3335 31.9987 53.3335C43.7854 53.3335 53.332 43.7868 53.332 32.0002C53.332 20.2135 43.7854 10.6668 31.9987 10.6668C20.212 10.6668 10.6654 20.2135 10.6654 32.0002Z"
          fillOpacity="0.6"/>
  </svg>
)

export default AttentionOutline
